import { render, staticRenderFns } from "./individuation.vue?vue&type=template&id=f2053dc0&scoped=true"
import script from "./individuation.vue?vue&type=script&lang=js"
export * from "./individuation.vue?vue&type=script&lang=js"
import style0 from "./individuation.vue?vue&type=style&index=0&id=f2053dc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2053dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2053dc0')) {
      api.createRecord('f2053dc0', component.options)
    } else {
      api.reload('f2053dc0', component.options)
    }
    module.hot.accept("./individuation.vue?vue&type=template&id=f2053dc0&scoped=true", function () {
      api.rerender('f2053dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/scrunchieArrangement/components/individuation.vue"
export default component.exports